export default __webpack_public_path__ + "d147b608e7d826d90d72e48f337668af.png";